const styles = theme => ({
  grid: {
    width: '100%',
    //maxWidth: 610,
    flexBasis: 'unset',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '752px',
    margin: 'auto',
  },
  photoButton: {
    marginRight: theme.spacing(2),
  },
})

export default styles
